package io.github.dautovicharis.charts

enum class LineChartRenderMode {
    Morph,
    Timeline,
}
